module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-intro"
  }, [_c('div', {
    staticClass: "block-intro__bg"
  }, [_c('object', {
    attrs: {
      "type": "image/svg+xml",
      "data": _vm.props.background,
      "aria-label": "Alternative Text"
    }
  })]), _c('div', {
    staticClass: "block-intro__container"
  }, [_c('div', {
    staticClass: "block-intro__body"
  }, [_c('div', {
    staticClass: "block-intro__text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7752f2cc","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/block/block-intro/block-intro.pug
// module id = 585
// module chunks = 1